import { useState, useEffect, useRef } from "react";
import style from "./textswitch.module.css";

const texts = [
  "Переведу текст на другой язык",
  "Отвечу на интересующие вас вопросы",
  "Решу ваши задачи",
  "Помогу с математикой",
  "Напишу код",
  "Переведу текст на другой язык",
  "Напишу резюме",
  "Даю медицинские советы",
  "Помогаю разобраться с финансами",
  "Разбираюсь в технике",
  "Помогаю в обучении",
  "Делюсь интересными идеями"
];

const TextSwitcher = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (intervalRef.current) return;

    intervalRef.current = setInterval(() => {
      setVisible(false);

      if (timeoutRef.current) clearTimeout(timeoutRef.current);

      timeoutRef.current = setTimeout(() => {
        setIndex(prev => (prev + 1) % texts.length);
        setVisible(true);
      }, 500);
    }, 3000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, []);

  return (
    <div style={{ position: "relative" /* или высота строки */ }}>
      <p
        className={`${style.fadeText} ${
          visible ? style.visible : style.hidden
        }`}
      >
        {texts[index]}
      </p>
    </div>
  );
};

export default TextSwitcher;
